window.scrollTo(0, 0);


    /* Анимация about */
    const text = document.getElementById('text');
const scaneSection = document.getElementById('scane');
let lastScroll = 0;
let animationDelay = 0; // Задержка перед началом движения
const speedFactor = 1.5; // Базовая скорость
const smoothness = 0.05; // Коэффициент плавности (0.1 = более плавно)

window.addEventListener('scroll', function() {
    const scaneOffset = scaneSection.offsetTop;
    const scrollY = window.scrollY - 200;
    
    // Параллакс с задержкой (двигается не сразу)
    if (scrollY >= scaneOffset) {
        const scrollValue = scrollY - scaneOffset;
        
        // Добавляем плавность через линейную интерполяцию (LERP)
        const targetMargin = scrollValue * speedFactor;
        const currentMargin = parseFloat(text.style.marginTop) || 0;
        const newMargin = currentMargin + (targetMargin - currentMargin) * smoothness;
        
        text.style.marginTop = newMargin + 'px';
    } else {
        text.style.marginTop = '0';
    }
    
    lastScroll = scrollY;
});
    /* //Анимация about */

/* Анимация hero */
        document.addEventListener('DOMContentLoaded', function() {
            // Получаем элемент текстового блока "Dive deeper. Glow longer."
            const animateElements = document.querySelectorAll('.scroll-animate');
            
            // Функция проверки видимости элемента
            function checkVisibility() {
                animateElements.forEach(element => {
                    const elementTop = element.getBoundingClientRect().top;
                    const elementVisible = 100; // На сколько пикселей элемент должен зайти в viewport
                    
                    if (elementTop < window.innerHeight - elementVisible) {
                        element.classList.add('visible');
                    }
                });
            }
            
            // Проверяем при загрузке
            checkVisibility();
            
            // И при скролле
            window.addEventListener('scroll', checkVisibility);
        });
/* //Анимация hero */

/* Слайдер амбасазоров */
        document.addEventListener('DOMContentLoaded', function() {
            const sliderTrack = document.getElementById('sliderTrack');
            const slides = document.querySelectorAll('.slide');
            const navDots = document.querySelectorAll('.nav-dot');
            const prevArrow = document.getElementById('prevArrow');
            const nextArrow = document.getElementById('nextArrow');

            let currentSlide = 0;
            const slideWidth = 250 + 20; // width + margin
            const slideCount = slides.length;
            let isDragging = false;
            let startPosX = 0;
            let currentTranslate = 0;
            let prevTranslate = 0;
            let animationID = 0;

            // Центрируем первый слайд
            function centerSlide(index) {
                const containerWidth = sliderTrack.parentElement.offsetWidth;
                const offset = (containerWidth / 2) - (slideWidth / 2) - (index * slideWidth);
                sliderTrack.style.transform = `translateX(${offset}px)`;
                currentTranslate = offset;
                prevTranslate = offset;
            }

            // Обновляем состояние слайдера
            function updateSlider() {
    // Обновляем классы слайдов
    slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === currentSlide);
    });

    // Обновляем точки навигации
    navDots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentSlide);
    });
    
    // Удаляем класс active со всех элементов watch_dial
    document.querySelectorAll('.watch_dial').forEach(watch => {
        watch.classList.remove('active');
    });
    
    // Добавляем класс active текущему элементу watch_dial
    document.getElementById('watch' + currentSlide).classList.add('active');
    document.getElementById('dial').style.transform = 'rotate(' + currentSlide * 90 + 'deg)';

    // Центрируем текущий слайд
    centerSlide(currentSlide);
}

            // Переключение на конкретный слайд
            function goToSlide(index) {
                if (index >= 0 && index < slideCount) {
                    currentSlide = index;
                    updateSlider();
                }
            }

            // Touch events для мобильных устройств
            function touchStart(e) {
                isDragging = true;
                startPosX = e.touches[0].clientX;
                cancelAnimationFrame(animationID);
                const style = window.getComputedStyle(sliderTrack);
                const matrix = new DOMMatrix(style.transform);
                prevTranslate = matrix.m41;
            }

            function touchMove(e) {
                if (!isDragging) return;
                const currentPosition = e.touches[0].clientX;
                const diff = currentPosition - startPosX;
                currentTranslate = prevTranslate + diff;
                sliderTrack.style.transform = `translateX(${currentTranslate}px)`;
            }

            function touchEnd() {
                isDragging = false;
                const movedBy = currentTranslate - prevTranslate;
                
                if (movedBy < -50 && currentSlide < slideCount - 1) {
                    goToSlide(currentSlide + 1);
                } else if (movedBy > 50 && currentSlide > 0) {
                    goToSlide(currentSlide - 1);
                } else {
                    goToSlide(currentSlide);
                }
            }

            // Инициализация
            centerSlide(0);

            // Навигация по точкам
            navDots.forEach(dot => {
                dot.addEventListener('click', () => {
                    goToSlide(parseInt(dot.getAttribute('data-index')));
                });
            });

            // Клик по слайду
            slides.forEach(slide => {
                slide.addEventListener('click', () => {
                    goToSlide(parseInt(slide.getAttribute('data-index')));
                });
            });

            // Стрелки навигации
            /*prevArrow.addEventListener('click', () => goToSlide(currentSlide - 1));
            nextArrow.addEventListener('click', () => goToSlide(currentSlide + 1));*/

            // Touch events
            sliderTrack.addEventListener('touchstart', touchStart, { passive: true });
            sliderTrack.addEventListener('touchmove', touchMove, { passive: false });
            sliderTrack.addEventListener('touchend', touchEnd);

            // Реакция на изменение размера окна
            window.addEventListener('resize', () => centerSlide(currentSlide));
        });
/* Слайдер амбасазоров */
   
   
        document.addEventListener('DOMContentLoaded', function() {
            // Navigation dropdown functionality
            const navItems = document.querySelectorAll('.nav-item');
            
            navItems.forEach(item => {
                item.addEventListener('mouseenter', () => {
                    document.querySelector('.nav').classList.add('scrolled');
                    item.querySelector('.dropdown').style.display = 'block';
                });
                
                item.addEventListener('mouseleave', () => {
                    item.querySelector('.dropdown').style.display = 'none';
                    if (!document.querySelector('.dropdown:hover')) {
                        document.querySelector('.nav').classList.remove('scrolled');
                    }
                });
            });
            
            // Keep white background if dropdown is hovered
            document.querySelectorAll('.dropdown').forEach(dropdown => {
                dropdown.addEventListener('mouseenter', () => {
                    document.querySelector('.nav').classList.add('scrolled');
                });
                
                dropdown.addEventListener('mouseleave', () => {
                    document.querySelector('.nav').classList.remove('scrolled');
                });
            });

            // Start animations
            
            document.querySelector('body').classList.add('noscroll');

         // Start animations
            setTimeout(function() {
                document.querySelector('.hero').classList.remove('fixed');
                document.querySelector('body').classList.remove('noscroll');
            
                window.scrollTo(0, 0);
              
                document.querySelector('.hero-bg').style.transform = 'scale(1.6)';
                
                // Show top bar and nav after background starts zooming
                setTimeout(function() {
                    document.querySelector('.top-bar').style.opacity = '1';
                    document.querySelector('.header-sections').style.opacity = '1';
                }, 500);
                
                // Move entire hero-center down after zoom completes (4.5s)
                setTimeout(function() {
                    // Смещаем весь блок вниз на половину высоты изображения плюс отступ
                    //document.querySelector('.hero-center').style.transform = 'translate(-50%, calc(-50% + 150px))';
                    
                    // Show hero image
                    setTimeout(function() {
                        document.querySelector('.hero-image').style.opacity = '1';
                        document.querySelector('.hero-image').style.transform = 'translateY(0)';
                        
                        // Show catalog button
                        setTimeout(function() {
                            document.querySelector('.catalog-btn-container').style.opacity = '1';
                            document.querySelector('.catalog-btn-container').style.transform = 'translateY(0)';
                        }, 300);
                    }, 300);
                }, 500);
            }, 3000);
            
        });

/*
document.addEventListener('DOMContentLoaded', function() {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    if (isTouchDevice) return;

    const heroSection = document.querySelector('.hero');
    const heroTitle = document.querySelector('.hero-title');
    const catalogBtn = document.querySelector('.catalog-btn-container');
    const heroImage = document.querySelector('.hero-image');
    const body = document.body;
    
    let isAnimating = false;
    let currentProgress = 0;
    const animationDuration = 500;
    const maxScale = 1.3;
    const maxTitlePosition = (heroSection.offsetHeight - heroTitle.getBoundingClientRect().height)/7;
    
    // Новые настройки чувствительности
    const isTrackpad = detectTrackpad();
    const sensitivity = isTrackpad ? 10 : 30; // Большее значение для мыши
    
    body.style.overflow = 'hidden';

    function handleScroll(e) {
        if (isAnimating) return;
        
        e.preventDefault();
        
        const delta = e.deltaY > 0 ? 0.9 : -0.9;
        currentProgress = Math.max(0, Math.min(animationDuration, currentProgress + delta * sensitivity));
        
        const progressRatio = currentProgress / animationDuration;
        const titlePosition = progressRatio * maxTitlePosition;
        
        heroTitle.style.transform = `translateY(${titlePosition}px)`;
        catalogBtn.style.transform = `translateY(${titlePosition}px)`;
        heroImage.style.transform = `scale(${1 + progressRatio * (maxScale - 1)}) translateY(${titlePosition/3}px)`;
        
        if (currentProgress >= animationDuration) {
            isAnimating = true;
            body.style.overflow = '';
            window.removeEventListener('wheel', handleScroll);
        }
    }
    
            setTimeout(function() {
    window.addEventListener('wheel', handleScroll, { passive: false });
              }, 4000);

    // Функция для определения тачпада
    function detectTrackpad() {
        // Тачпады обычно имеют небольшие значения deltaY с плавными событиями wheel
        let isTrackpad = false;
        const testHandler = (e) => {
            if (Math.abs(e.deltaY) !== 0 && Math.abs(e.deltaY) < 10) {
                isTrackpad = true;
            }
          
            window.removeEventListener('wheel', testHandler);
        };
        window.addEventListener('wheel', testHandler, { once: true, passive: true });
        return isTrackpad;
    }
});*/